import BillingsOrderTaxiRailyAddRequest, {
  BillingsOrderTaxiRailyAddRequestBillingNode,
} from "../../../../../api/raily/billings/order/taxi-raily/add/billings-order-taxi-raily-add.request";
import BillingsOrderTaxiRailyAddParams, {
  BillingsOrderTaxiRailyAddParamsBillingNode,
} from "./billings-order-taxi-raily-add-params";

const createBillingNode = (
  node: BillingsOrderTaxiRailyAddParamsBillingNode,
): BillingsOrderTaxiRailyAddRequestBillingNode => {
  return {
    allowCharge: node.allowCharge,
    checkoutDate: node.checkoutDate,
    checkoutEventId: node.checkoutEventId,
    description: node.description,
    distance: node.distance,
    editableCoordinates: node.editableCoordinates,
    haltingTime: node.haltingTime,
    highwayCharge: node.highwayCharge,
    id: node.id,
    lat: node.lat,
    lon: node.lon,
    nodeId: node.nodeId,
    orderId: node.orderId,
    plannedDate: node.plannedDate,
    plannedDistance: node.plannedDistance,
  };
};

const createBillingNodes = (
  nodes: BillingsOrderTaxiRailyAddParamsBillingNode[],
): BillingsOrderTaxiRailyAddRequestBillingNode[] => {
  return nodes.map(createBillingNode);
};

const create = (
  params: BillingsOrderTaxiRailyAddParams,
): BillingsOrderTaxiRailyAddRequest => {
  return {
    billingNodes: createBillingNodes(params.billingNodes),
    billingType: params.billingType,
    discount: params.discount,
    orderId: params.orderId,
  };
};

const billingsOrderTaxiRailyAddParamsFactory = {
  create,
};

export default billingsOrderTaxiRailyAddParamsFactory;
